module.exports = __webpack_public_path__ + "static/media/Suddhabumi.96215d5d.png";